import { render } from "./HeaderBlock.vue?vue&type=template&id=e895450c&scoped=true"
import script from "./HeaderBlock.vue?vue&type=script&lang=js"
export * from "./HeaderBlock.vue?vue&type=script&lang=js"

import "./HeaderBlock.vue?vue&type=style&index=0&id=e895450c&lang=scss"
import "./HeaderBlock.vue?vue&type=style&index=1&id=e895450c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e895450c"]])

export default __exports__